import { API_URL } from '../../../utils/config';

export const ADD_PROFILE_URL = `${API_URL}/employee`;
export const EDIT_PROFILE_URL = `${API_URL}/employee/edit`;
